import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Drawer,
  Form,
  InputNumber,
  Modal,
  Popconfirm,
  Radio,
  Row,
  Select,
  Space,
} from 'antd';
import { useMounted } from '../../hooks/useMounted';
import IntlMessage from '../../components/IntlMessage';
import { momentLocalizer, Calendar } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import useTime from '../../hooks/useTime';
import rateApi from '../../api/rates';
import Currency from '../../components/Currency';
import UpdateRateForm from './UpdateRateForm';
import routeSegmentsApi from '../../api/route-segment';
import { useIntl } from 'react-intl';
import rateHistoriesApi from '../../api/rate-histories';
import dayjs from 'dayjs';

import 'moment/locale/fr';
import { formatCurrencyCustom } from '../../utils/helpers';

const { Option } = Select;
const RouteCalendar = (props) => {
  const { open, onClose, currentData, onReload, reload } = props;

  // Ensure react-big-calendar renders in French via moment.
  moment.locale('fr');

  const localizer = momentLocalizer(moment);
  const { convertToAnyTimezone, formatAsISOString } = useTime();
  const { isMounted } = useMounted();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [option, setOption] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState([]);
  const [isModalUpdate, setIsModalUpdate] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 100000,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  const [form] = Form.useForm();
  const intl = useIntl();
  const [openDraw, setOpenDraw] = useState(false);

  const onCloseDraw = () => {
    setOpenDraw(false);
  };
  const showDrawer = () => {
    if (option) {
      setOpenDraw(true);
    } else {
      Modal.warning({
        title: 'Please add segment before adding new rates',
        okText: intl.formatMessage({ id: 'global.close' }),
      });
    }
  };
  const [mode, setMode] = useState('date');
  const onChangeMode = (value) => {
    setMode(value);
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };
  const handleCreateStatus = () => {
    let data = {};
    const segmentIds = option.id;
    data.segment_id = segmentIds;
    data.weekdays = form.getFieldValue('weekdays');
    if (mode === 'day') {
      data.from_date = form.getFieldValue('from_date');
      data.to_date = form.getFieldValue('from_date');
    } else {
      data.from_date = form.getFieldValue('from_date');
      data.to_date = form.getFieldValue('to_date');
    }

    data.status = form.getFieldValue('status');
    // data.cabin_id = cabin.id;
    // console.log(data);
    routeSegmentsApi
      .updateStatusRates(data)
      .then(() => {
        setLoading(false);
        Modal.success({
          title: 'Success',
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        onReload();
        onCloseDraw();
      })
      .catch((error) => {
        console.error(error);
        Modal.error({
          title: error.data.message,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      });
  };

  const itemsNest = [
    {
      key: '1',
      label: 'Status',
      children: (
        <>
          <Form.Item name="status">
            <Radio.Group>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Button type="primary" size="small" onClick={handleCreateStatus}>
            Valider
          </Button>
        </>
      ),
    },
  ];
  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = {
          ...values,
          segment_id: option.id,
        };
        if (mode === 'day') {
          data['to_date'] = data.from_date;
        }
        data.from_date = formatAsISOString(data.from_date);
        data.to_date = formatAsISOString(data.to_date);
        let rateHistoryPayload = { ...data };
        rateHistoryPayload.price = data.adult_price;
        delete rateHistoryPayload?.year;
        rateHistoryPayload.week_days = rateHistoryPayload.weekdays
          .map((item) => {
            if (`${item}` === '1') return 'Monday';
            if (`${item}` === '2') return 'Tuesday';
            if (`${item}` === '3') return 'Wednesday';
            if (`${item}` === '4') return 'Thursday';
            if (`${item}` === '5') return 'Friday';
            if (`${item}` === '6') return 'Saturday';
            return 'Sunday';
          })
          .join(', ');
        delete rateHistoryPayload?.weekdays;
        Promise.all([
          rateApi.create(data),
          rateHistoriesApi.create(rateHistoryPayload),
        ])
          .then(() => {
            setLoading(false);
            onCloseDraw();
            onReload();
            Modal.success({
              title: 'Success',
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            form.resetFields();
          })
          .catch((error) => {
            console.error(error);
            Modal.error({
              title: error.data.message,
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            setLoading(false);
          });
      })
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      if (filter.filter_name) {
        let result = await rateApi.getAll(filter);
        let events = result.data;
        events = events.map((item) => {
          return {
            start: new Date(convertToAnyTimezone(item.date)),
            end: new Date(convertToAnyTimezone(item.date)),
            title: (
              <div
                style={{
                  padding: '0 5px',
                  backgroundColor: !item.status && '#999292ee',
                  height: '70px',
                }}>
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '8px',
                  }}>
                  {formatCurrencyCustom(
                    +item.adult_price,
                    JSON.parse(currentData?.operator?.params || '{}'),
                  )}
                  {/* )} */}
                </div>
              </div>
            ),
            ...item,
          };
        });
        setItems(events);
      }
      setLoading(false);
    }
    fetchData();
  }, [filter, options, reload]);

  const fetch = useCallback(async () => {
    if (isMounted.current) {
      const filter_option = {
        limit: 9999,
        page: 1,
        order_by: 'id',
        order_dir: 'ASC',
        filter_name: ['route_id', 'status'],
        filter_value: [currentData?.id, 1],
      };

      let options = await routeSegmentsApi.getAll(filter_option);
      setOptions(options.data);
      if (options.data.length > 0) {
        setOption(options.data[0]);
        setFilter((filter) => ({
          ...filter,
          route_id: currentData?.id,
          filter_name: ['segment_id'],
          filter_value: [options?.data[0]?.id],
        }));
      }
    }
  }, [isMounted, currentData]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const handleCancel = () => {
    onClose();
  };

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setIsModalUpdate(true);
  };

  const handleChangeOption = (e) => {
    const data = options.filter((item) => item.id === e);

    setOption(data[0]);
    setFilter((filter) => ({
      ...filter,
      filter_name: ['segment_id'],
      filter_value: [data[0]?.id],
    }));
  };

  const calendarMessagesFr = {
    date: 'Date',
    time: 'Heure',
    event: 'Événement',
    allDay: 'Toute la journée',
    week: 'Semaine',
    work_week: 'Semaine ouvrée',
    day: 'Jour',
    month: 'Mois',
    previous: 'Précédent',
    next: 'Suivant',
    yesterday: 'Hier',
    tomorrow: 'Demain',
    today: "Aujourd'hui",
    agenda: 'Agenda',
    noEventsInRange: 'Aucun événement sur cette période.',
    showMore: (total) => `+${total} de plus`,
  };

  const handleDeletePrice = () => {
    setLoading(true);

    form
      .validateFields(['weekdays', 'mode', 'from_date', 'to_date'])
      .then((values) => {
        let data = {
          ...values,
          segment_id: option.id,
        };
        if (mode === 'day') {
          data['to_date'] = data.from_date;
        }
        data.adult_price = [0];
        data.from_date = formatAsISOString(data.from_date);
        data.to_date = formatAsISOString(data.to_date);
        let rateHistoryPayload = { ...data };
        rateHistoryPayload.price = data.adult_price;
        delete rateHistoryPayload?.year;
        rateHistoryPayload.week_days = rateHistoryPayload.weekdays
          .map((item) => {
            if (`${item}` === '1') return 'Monday';
            if (`${item}` === '2') return 'Tuesday';
            if (`${item}` === '3') return 'Wednesday';
            if (`${item}` === '4') return 'Thursday';
            if (`${item}` === '5') return 'Friday';
            if (`${item}` === '6') return 'Saturday';
            return 'Sunday';
          })
          .join(', ');
        delete rateHistoryPayload?.weekdays;
        rateHistoryPayload.params = JSON.stringify({ action: 'delete' });
        Promise.all([
          routeSegmentsApi.deleteMultipleRate(data),
          rateHistoriesApi.create(rateHistoryPayload),
        ])
          .then(() => {
            setLoading(false);
            // onCloseDraw();
            onReload();
            Modal.success({
              title: 'Success',
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            form.resetFields();
          })
          .catch((error) => {
            console.error(error);
            Modal.error({
              title: error.data.message,
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            setLoading(false);
          });
      })
      .catch(() => setLoading(false));
  };

  return (
    <React.Fragment>
      <Modal
        title={<IntlMessage id="global.update" />}
        open={open}
        destroyOnClose={true}
        onCancel={handleCancel}
        width="80%"
        footer={[
          <Button key="submit" type="primary" htmlType="submit">
            {<IntlMessage id="global.save" />}
          </Button>,
        ]}>
        <Row justify="space-between">
          <Col span={18}>
            <Select
              showSearch
              placeholder={'Select segment'}
              onChange={handleChangeOption}
              style={{ minWidth: '200px' }}
              // allowClear={true}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              value={option?.id}>
              {options.length
                ? options.map((option, i) => {
                    return (
                      <Option key={i} value={option.id}>
                        {option?.start_stop?.title} - {option?.end_stop?.title}
                      </Option>
                    );
                  })
                : null}
            </Select>
          </Col>
          <Col>
            <Space>
              <Button type="primary" size="small" onClick={showDrawer}>
                <IntlMessage id="global.add_new" />
              </Button>

              {/* <Button
                size="small"
                danger
                onClick={onClearRate}
                disabled={!option}>
                <IntlMessage id="global.clear" />
              </Button> */}
            </Space>
          </Col>
        </Row>
        <Calendar
          localizer={localizer}
          events={items}
          defaultDate={new Date()}
          startAccessor="start"
          endAccessor="end"
          culture={'fr'}
          timeslots={3}
          style={{ height: 770, width: '100%', marginTop: '16px' }}
          scrollToTime={new Date()}
          selectable={true}
          toolbar={true}
          messages={calendarMessagesFr}
          onSelectEvent={handleEventClick}
        />
        <Drawer
          title={`${option?.start_stop?.title} - ${option?.end_stop?.title}`}
          placement="right"
          onClose={onCloseDraw}
          open={openDraw}
          width="30%"
          footer={
            <Space>
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={handleSubmit}>
                {<IntlMessage id="global.save" />}
              </Button>
            </Space>
          }>
          <Form
            layout="vertical"
            form={form}
            initialValues={{
              weekdays: ['0', '1', '2', '3', '4', '5', '6'],
              status: 1,
              from_date: dayjs(),
              to_date: dayjs().add(30, 'day'),
              price: 1,
              seat: 1,
            }}
            labelAlign="left"
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}>
            <Row
              justify={'start'}
              align={'bottom'}
              gutter={[10, 10]}
              style={{ width: '100%' }}>
              <Col span={6}>
                <Form.Item
                  name={'mode'}
                  initialValue={'date'}
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfeild" />,
                    },
                  ]}>
                  <Select
                    placeholder="Select mode"
                    onSelect={onChangeMode}
                    options={[
                      {
                        value: 'date',
                        label: <IntlMessage id="global.date" />,
                      },
                      {
                        value: 'day',
                        label: <IntlMessage id="global.day" />,
                      },
                    ]}></Select>
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item
                  label={
                    mode === 'date' && <IntlMessage id="global.from_date" />
                  }
                  name="from_date"
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfield" />,
                    },
                  ]}>
                  <DatePicker
                    // showTime
                    format={'DD/MM/YYYY'}
                    style={{ width: '100%' }}
                    // onChange={handleDate}
                  />
                </Form.Item>
              </Col>
              {mode === 'date' && (
                <Col span={9}>
                  <Form.Item
                    label={<IntlMessage id="global.to_date" />}
                    name="to_date"
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id="global.requiredfield" />,
                      },
                    ]}>
                    <DatePicker
                      // showTime
                      format={'DD/MM/YYYY'}
                      style={{ width: '100%' }}
                      // onChange={handleDate}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>

            <Form.Item
              label={<IntlMessage id="global.weekdays" />}
              name="weekdays"
              rules={[
                {
                  required: true,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}>
              <Checkbox.Group
                style={{ width: '100%' }}
                //  onChange={onChange}
                value={['0', '1', '2', '3', '4', '5', '6']}>
                <Row>
                  <Col span={6}>
                    <Checkbox value="1" checked>
                      Lundi
                    </Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="2" defaultChecked>
                      Mardi
                    </Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="3">Mercredi</Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="4">Jeudi</Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="5">Vendredi</Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="6">Samedi</Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="0">Dimanche</Checkbox>
                  </Col>
                </Row>
              </Checkbox.Group>
            </Form.Item>
            <Form.Item
              label={<IntlMessage id="global.adult_price" />}
              name="adult_price"
              rules={[
                {
                  required: true,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}>
              <InputNumber
                min={1}
                placeholder="Prix"
                formatter={(value) => {
                  if (value === undefined || value === null || value === '') {
                    return '';
                  }

                  const currencySymbol = (
                    JSON.parse(currentData?.operator?.params || '{}')
                      ?.sale_currency_symbol || 'CFA'
                  )
                    .toString()
                    .trim();

                  const formatted = `${value}`
                    .replace(/\s*[A-Za-z]+\s*$/g, '')
                    .replace(/\s/g, '') // remove existing spaces
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // 👈 dùng space thay vì comma

                  return `${formatted} ${currencySymbol}`;
                }}
                parser={(value) => {
                  if (!value) return '';
                  return value
                    .toString()
                    .replace(/\s/g, '') // 👈 remove space
                    .replace(/[^\d.]/g, '');
                }}
                style={{ width: 200 }}
              />
            </Form.Item>

            <Collapse
              items={itemsNest}
              style={{ marginTop: '20px' }}
              defaultActiveKey={'1'}
            />
          </Form>

          <Popconfirm
            title="Supression départs"
            description="Êtes-vous sûr de vouloir enlever les départs pour les jours choisis ?"
            onConfirm={handleDeletePrice}
            okText="Oui"
            cancelText="Non">
            <Button
              loading={loading}
              type="primary"
              variant="solid"
              // onClick={handleDeletePrice}
              style={{ marginTop: 24 }}
              danger>
              Annuler
            </Button>
          </Popconfirm>
        </Drawer>
        {isModalUpdate ? (
          <UpdateRateForm
            open={isModalUpdate}
            onClose={() => setIsModalUpdate(false)}
            currentData={selectedEvent}
            onReload={onReload}
          />
        ) : null}
      </Modal>
    </React.Fragment>
  );
};

export default RouteCalendar;
